import { createElement, memo } from 'react';
import classNames from '@/utils/classNames';
import type BaseButton from '@/components/Button/particles/BaseButton';

import type { ElementType, ComponentProps } from 'react';

type ButtonIconProps = {
  as: ElementType;
  trailing?: boolean;
  main?: boolean;
} & ComponentProps<typeof BaseButton>;

const ButtonIcon = ({
  as,
  className,
  main,
  trailing,
  ...props
}: ButtonIconProps) =>
  createElement(as, {
    className: classNames(
      'h-5 w-5 shrink-0',
      {
        'order-first -ml-0.5': !trailing && !main,
        'order-last -mr-0.5': trailing,
      },
      className,
    ),
    'aria-hidden': true,
    ...props,
  });

export default memo(ButtonIcon);
